import { clone } from '@jkhy/frontend-utils/functions';
import { DashboardInformationCenterModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

const nullInformationCenterMessage: DashboardInformationCenterModelDto = {
    title: '',
    description: '',
    sequence: 0,
    type: '',
};

export class InformationCenterMessage extends DomainEntity<DashboardInformationCenterModelDto> {
    constructor(dto = clone(nullInformationCenterMessage)) {
        super(dto);
    }

    public createDefault(): this {
        return new InformationCenterMessage(clone(nullInformationCenterMessage)) as this;
    }

    public get title() {
        return this.dto.title;
    }

    public get description() {
        return this.dto.description;
    }

    public get sequence() {
        return this.dto.sequence;
    }

    public get type() {
        return this.dto.type;
    }
}
